import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ 
  service, 
  onViewDetails, 
  onReassign,
  onContactCustomer,
  onUpdateStatus 
}) => {
  const getUrgencyColor = (urgency) => {
    switch (urgency) {
      case 'urgent':
        return 'bg-error/10 text-error border-error/20';
      case 'today':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'scheduled':
        return 'bg-primary/10 text-primary border-primary/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'planned':
        return 'bg-secondary/10 text-secondary';
      case 'en_route':
        return 'bg-primary/10 text-primary';
      case 'on_site':
        return 'bg-warning/10 text-warning';
      case 'completed':
        return 'bg-success/10 text-success';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'planned':
        return 'Planifié';
      case 'en_route':
        return 'En route';
      case 'on_site':
        return 'Sur place';
      case 'completed':
        return 'Terminé';
      default:
        return 'Inconnu';
    }
  };

  const getUrgencyLabel = (urgency) => {
    switch (urgency) {
      case 'urgent':
        return 'Urgent';
      case 'today':
        return "Aujourd'hui";
      case 'scheduled':
        return 'Planifié';
      default:
        return 'Normal';
    }
  };

  return (
    <div className={`bg-card rounded-lg border-2 p-4 hover:shadow-md transition-shadow ${getUrgencyColor(service?.urgency)}`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-semibold text-foreground">{service?.serviceType}</h3>
            <span className={`text-xs px-2 py-1 rounded-full ${getStatusColor(service?.status)}`}>
              {getStatusLabel(service?.status)}
            </span>
          </div>
          <p className="text-sm text-muted-foreground">{service?.customerName}</p>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full font-medium ${getUrgencyColor(service?.urgency)}`}>
          {getUrgencyLabel(service?.urgency)}
        </span>
      </div>
      <div className="space-y-2 mb-3">
        <div className="flex items-center gap-2 text-sm">
          <Icon name="MapPin" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="text-foreground truncate">{service?.address}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Clock" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="text-foreground">{service?.scheduledTime}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="User" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="text-foreground">{service?.assignedTechnician || 'Non assigné'}</span>
        </div>
        {service?.eta && (
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Navigation" size={16} className="text-primary flex-shrink-0" />
            <span className="text-primary font-medium">ETA: {service?.eta}</span>
          </div>
        )}
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Phone"
          onClick={() => onContactCustomer(service?.id)}
        >
          Client
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="UserPlus"
          onClick={() => onReassign(service?.id)}
        >
          Réassigner
        </Button>
        <Button
          variant="default"
          size="sm"
          iconName="Eye"
          onClick={() => onViewDetails(service?.id)}
          className="flex-1"
        >
          Détails
        </Button>
      </div>
    </div>
  );
};

export default ServiceCard;